<template>
	<div v-if="total.length || taxes" class="total">
		<CurrencyPopup :showCurrencyPopup="showCurrencySelector" :currencies="currencies" :currencyModule="currencyModule" @changeCurrency="currencyChanged" @hide="hidePopup" />
		<div v-for="item in total" v-bind:key="item.id" class="total__line">
			<div class="total__label">{{ item.title }}</div>
			<div class="value total__price" v-for="val in item.value" :key="val.id" v-html="val"></div>
		</div>

		<div v-if="taxes" class="total__line total__line--taxes">
			<div class="total__line total__line--taxes" v-html="taxes.title"></div>
			<div class="value" v-for="val in taxes.value" :key="val.id" v-html="val"></div>
		</div>
		<div class="total__line total__line--taxes">
			<div class="label">

			</div>
			<div class="value value--currency">
				<a href="#" v-if="currencies && showCurrencySelector" ref="currencyToggle" @click.prevent="hidePopup"  @keydown.enter.prevent="hidePopupEnter" v-html="language.changeCurrency"></a>
				<a href="#" v-if="currencies && !showCurrencySelector" ref="currencyToggle" @click.prevent="showPopup" @keydown.enter.prevent="showPopupEnter" v-html="language.changeCurrency"></a>
			</div>
		</div>
	</div>
</template>

<script>
import CurrencyPopup from './CurrencyPopup'
export default {
	name: 'Total',
	components: {
		CurrencyPopup
	},

	data: function(){
		return {
			currencies: null,
			currencyModule: null,
			showCurrencySelector: false
		}
	},

	mounted() {
		// there is an event implemented for wmx scripts to be loaded
		const that = this
		document.body.addEventListener('wmx:loaded', function(){
			that.currencies = Object.assign({}, window.currency_symbols)
			for (let i = 0; i < that.currencies.length; i++) {
				that.currencies[i].active = false
			}
			that.currencyModule = window.citizenm.currencyModule
		})
	},

	computed: {
		total() {
			return this.$store.state.total
		},
		taxes() {
			return this.$store.state.taxes
		},
		language() {
			return this.$store.state.language
		}
	},
	methods: {
		showPopup(e){
			this.showCurrencySelector = true
			console.log(e)
			console.log('showPopup')
			console.log(this.showCurrencySelector)
		},
		hidePopup(){
			this.showCurrencySelector = false
		},
		showPopupEnter(e){
			this.showCurrencySelector = true
			console.log(e)
		},
		hidePopupEnter(e){
			console.log(e)
			this.showCurrencySelector = false
		},
		currencyChanged() {
			this.$emit('changeCurrency')
			this.showCurrencySelector = false
		}
	},
	watch: {
		// currencyPopupOpened() {
		// 	this.showCurrencySelector = this.currencyPopupOpened
		// }
	}
}
</script>